import {
  Navigate,
  useLocation,
  useParams,
  useSearchParams
} from "react-router-dom";

import { Redirect } from "shared/components/Redirect";

export const RequireLoginRedirect = () => {
  const location = useLocation();
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export const RedirectToHome = () => <Navigate to="/" />;

export const RedirectToOnboarding = () => <Redirect href="/onboarding" />;

export const ApplicationReportsRedirect = () => {
  const { applicationId } = useParams();
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  const qsSuffix = qs ? `?${qs}` : "";
  return <Navigate to={`/applications/${applicationId}${qsSuffix}`} replace />;
};
